export default __webpack_public_path__ + "static/media/redpanda.4dc2804f.png";